<ion-header gaCategory="invite_user_toolbar" slp-ionic-platform>
  <ion-toolbar>
    <ion-button *ngIf="wizardIndex < 4" id="backButton" slot="start" (click)="previousStep()" [disabled]="wizardIndex <= 1">
      <ion-icon name="chevron-back" slot="start"></ion-icon><span>{{ "administration.inviteUser.back" | translate }}</span>
    </ion-button>
    <div class="wizard-ellipses">
      <ion-icon name="ellipse" *ngIf="wizardIndex < 4" [ngClass]="{'active': wizardIndex === 1}" (click)="wizardIndex > 1 && goToStep(1)"></ion-icon>
      <ion-icon name="ellipse" *ngIf="wizardIndex < 4" [ngClass]="{'active': wizardIndex === 2}" (click)="wizardIndex > 2 && goToStep(2)"></ion-icon>
      <ion-icon name="ellipse" *ngIf="wizardIndex < 4 && !isInternalOrg" [ngClass]="{'active': wizardIndex === 3}" (click)="wizardIndex > 3 && goToStep(3)"></ion-icon>
      <ion-icon name="ellipse" *ngIf="wizardIndex < 4" [ngClass]="{'active': wizardIndex === 4}" (click)="wizardIndex > 4 && goToStep(4)"></ion-icon>
    </div>
    <ion-button gaEvent="wizard_next_step" *ngIf="wizardIndex < 4" id="nextButton" slot="end" (click)="nextStep()" [disabled]="!canContinue">
      <ion-icon name="chevron-forward" slot="end"></ion-icon><span>
        {{ (wizardIndex === 3 || (wizardIndex === 2 && isInternalOrg) ? 
          ( user.id ? "administration.inviteUser.resendInvitation" : "administration.inviteUser.inviteUser") : 
          "administration.inviteUser.next") 
          | translate }}
      </span>
    </ion-button>
  </ion-toolbar>
</ion-header>
<ion-content gaCategory="invite_user" slp-ionic-platform>
  <ion-toolbar class="title">
    <span *ngIf="(!error && wizardIndex >= 5)" class="full-name">{{ inviteUserForm.value?.firstName }} {{ inviteUserForm.value?.lastName }}</span>
    <h2 *ngIf="(!error && wizardIndex !== 5)">{{ "administration.inviteUser.title" | translate }}</h2>
    <ion-icon id="dismissIcon" class="ion-margin close" slot="end" name="close-outline" (click)="dismiss()"></ion-icon>
  </ion-toolbar>
  <form [formGroup]="inviteUserForm" *ngIf="!error && wizardIndex === 1">
    <ion-item lines="none">
      <b>{{ "administration.inviteUser.userInformation" | translate }}</b>
    </ion-item>
    <ion-row>
      <ion-col>
        <div class="names">
          <ion-item lines="none" *ngIf="platform.isDesktop()">
            <ion-label class="input-label">{{ "administration.inviteUser.firstName" | translate }}</ion-label>
          </ion-item>
          <ion-item class="textfield names" [lines]="platform.isDesktop() ? 'full' : 'none'">
            <ion-label position="floating" *ngIf="!platform.isDesktop()">{{
              "administration.inviteUser.firstName" | translate
            }}</ion-label>
            <ion-input id="firstNameInput" type="text" formControlName="firstName" required></ion-input>
          </ion-item>
          <validation-messages [control]="inviteUserForm.controls.firstName"></validation-messages>
        </div>
      </ion-col>
      <ion-col>
        <div class="names">
          <ion-item lines="none" *ngIf="platform.isDesktop()">
            <ion-label class="input-label">
              {{ "administration.inviteUser.lastName" | translate }}
            </ion-label>
          </ion-item>
          <ion-item class="textfield names" [lines]="platform.isDesktop() ? 'full' : 'none'">
            <ion-label position="floating" *ngIf="!platform.isDesktop()">{{
              "administration.inviteUser.lastName" | translate
            }}</ion-label>
            <ion-input id="lastNameInput" type="text" formControlName="lastName" required></ion-input>
          </ion-item>
          <validation-messages [control]="inviteUserForm.controls.lastName"></validation-messages>
        </div>
      </ion-col>
    </ion-row>
    <ion-item lines="none" *ngIf="platform.isDesktop()">
      <ion-label class="input-label email">{{ "administration.inviteUser.email" | translate }}</ion-label>
      <ion-icon *ngIf="domains.length > 0" name="information-circle" (click)="openDomains($event)"></ion-icon>
    </ion-item>
    <ion-item class="textfield" [lines]="platform.isDesktop() ? 'full' : 'none'">
      <ion-label position="floating" *ngIf="!platform.isDesktop()">{{ "administration.inviteUser.email" | translate }}</ion-label>
      <ion-input id="emailInput" type="text" formControlName="email" required></ion-input>
    </ion-item>
    <validation-messages [control]="inviteUserForm.controls.email"></validation-messages>
  </form>
  <app-user-permissions [userId]="user.id" #userPermissions [orgId]="orgId" [readonly]="false" [(roles)]="roles" [(claims)]="claims" *ngIf="wizardIndex === 2"></app-user-permissions>
  <app-hierarchy *ngIf="wizardIndex === 3 && !isInternalOrg" [userId]="user.id" [cloneUser]="cloneUser" [(selectedUserHierarchy)]="userHierarchy" [readonly]="false"></app-hierarchy>
  <form *ngIf="!error && wizardIndex === 4">
    <ion-item #successMessage lines="none" *ngIf="showSuccessMessage">
      <span class="successMessage">{{ "administration.inviteUser.inviteSuccessfulMessage" | translate: { firstName: inviteUserForm.value?.firstName, lastName:inviteUserForm.value?.lastName } }}</span>
    </ion-item>
  </form>
  <div *ngIf="error" class="ion-text-center error-load">
    <h5>{{ "administration.InternalError" | translate }}</h5>
  </div>
</ion-content>

<ion-popover #popoverDom reference="event">
  <ng-template>
    <ion-list>
      <ion-item lines="none" *ngFor="let item of domains">
        <ion-label>{{item}}</ion-label>
      </ion-item>
    </ion-list>
  </ng-template>
</ion-popover>